module.exports = __webpack_public_path__ + "img/learn-1.ff39aa54.png";